<template>
  <form @submit.prevent="emitSave" id="MappingTableAddEditDialog">
    <h4 class="mb-4">{{ 'ADD' | translate }}</h4>
  
    <div class="form-group" id="MappingTableAddEditDialog-formGroup-AFD-label">
      <label>{{ 'AFD label' | translate }} <span class="asterisk">*</span></label>
      <input type="text"
             class="form-control form-control-sm"
             v-model="mapping.label"
             required
             id="MappingTableAddEditDialog-formGroup-AFD-label-input">
    </div>
  
    <div class="form-group" id="MappingTableAddEditDialog-formGroup-Mapping">
      <label>{{ 'Mapping' | translate }}</label>
      <input type="text"
             class="form-control form-control-sm"
             v-model="mapping.value"
             required
             id="MappingTableAddEditDialog-formGroup-Mapping-input">
    </div>
    <div style="height: 300px; white-space: nowrap; overflow-y: auto;">
      <template v-for="productLineName in productLineNames">
        <div class="form-group" :id="'MappingTableAddEditDialog-formGroup-'+productLineName">
          <label>{{ productLineName  | translate('product')  }}</label>
          <input type="checkbox"
                 class="form-control form-control-sm"
                 :value="productLineName"
                 v-model="checkedProductLines"
                 :id="'MappingTableAddEditDialog-formGroup-input-'+productLineName">
        </div>
      </template>
    </div>
    <div class="mt-4 text-right" id="MappingTableAddEditDialog-formGroup-buttons">
  
      <button class="btn btn-link" type="button"
              @click="emitClose"
              id="MappingTableAddEditDialog-closeButton"
      >{{ 'CLOSE' | translate }}</button>
  
      <button class="btn btn-primary"
              type="submit"
              :disabled="!isFormValid"
              id="MappingTableAddEditDialog-addButton"
      >{{ 'ADD' | translate }}</button>
  
    </div>
  </form>
</template>

<script>
export default {
  props: ['edited', 'productLineNames'],
  data() {
    return {
      mapping: {},
      checkedProductLines: [] // Added checkedProductLines data property
    };
  },
  computed: {
    isFormValid() {
      return this.mapping.label && this.mapping.value;
    }
  },
  methods: {
    emitSave() {
      this.mapping.productLines = [...this.checkedProductLines]; // Update mapping.productLines
      this.$emit(this.edited ? 'update' : 'save', this.mapping);
      this.mapping = {};
      this.checkedProductLines = []; // Reset checkedProductLines array
    },
    emitClose() {
      this.checkedProductLines = []; // Reset checkedProductLines array
      this.$emit('close');
      this.mapping = {};
    },
    initializeCheckboxes() {
      // Initialize checkedProductLines based on mapping.productLines
      this.checkedProductLines = [...this.mapping.productLines];
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.mapping = { ...newVal };
      this.initializeCheckboxes(); // Initialize checkboxes when data changes
    }
  },
  mounted() {
    this.initializeCheckboxes(); // Initialize checkboxes on component mount
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

.vdp-datepicker__calendar {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mapping/MappingAddEditDialog.vue